const translation = {
  title: 'Inference Service',
  deployment: 'Deployment Model Inference Service',
  createDeployment: 'Create Service',
  modelName: 'Select a Model',
  serviceName: 'Service Name',
  searchPlaceholder: 'Search',
  list: {
    empty_text: 'No Data',
  },
  newDeployment: {
    startToCreate: 'Deployment a new model inference service',
  },
  // DeploymentList component translations
  idAndName: 'Name / ID',
  status: 'Status',
  permission: 'Permission',
  model: 'Model',
  image: 'Image',
  resourceInfo: 'Resource Info',
  replicas: 'Replicas',
  createUpdateTime: 'Created/Updated Time',
  createdAt: 'Created At',
  updatedAt: 'Updated At',
  accessEntry: 'Access Entry',
  accessService: 'Access Service',
  setModel: 'Set Model',
  password: 'Password: ******',
  operations: 'Operations',
  stop: 'Stop',
  start: 'Start',
  logs: 'Logs',
  inferenceLog: 'Inference Log: ',
  editService: 'Edit Service',
  delete: 'Delete',
  deleteService: 'Delete Service',
  more: 'More',
  providerNotFound: 'Provider not found!',

  // DeploymentDetail component translations
  deploymentDetail: {
    title: 'Inference Service Detail',
    tab: {
      detail: 'Detail',
      log: 'Log',
      event: 'Event',
      monitor: 'Monitor',
      pod: 'Pod',
    },
  },

  // DeploymentForm component translations
  form: {
    serviceName: 'Service Name',
    serviceNameTooltip: 'Unique name for the inference service. Supports letters, numbers and hyphens. Cannot be changed after creation',
    serviceType: 'Service Type',
    serviceTypeTooltip: 'Stateless services suit most inference scenarios; Stateful services are for scenarios requiring persistent storage',
    stateless: 'Stateless',
    stateful: 'Stateful',
    deploymentPermission: 'Deployment Permission',
    deploymentPermissionTooltip: 'Set access permission: private is visible only to you, public is visible to all project members',
    deploymentResource: 'Deployment Resource',
    deploymentResourceTooltip: 'Select computing resources for the service, including GPU type, quantity and instance specification',
    storageMount: 'Storage Mount',
    storageMountTooltip: 'Mount storage disks, models or datasets to specified container paths for data access and persistent storage',
    deploymentModel: 'Deployment Model',
    deploymentModelTooltip: 'Select the model to deploy. The model will be mounted into the container for the inference service',
    modelVersion: 'Model Version',
    modelVersionTooltip: 'Select the model version to deploy. Different versions may correspond to different training results or parameter configurations',
    inferenceImage: 'Inference Image',
    inferenceImageTooltip: 'Select the container image for the inference service. The image should contain the inference framework and required dependencies',
    workingDirectory: 'Working Directory',
    workingDirectoryTooltip: 'Working directory path when the container starts. Startup commands will be executed in this directory',
    startupCommand: 'Startup Command',
    startupCommandTooltip:
      'System environment variables, referenced via "{{variable_name}}": model_id: Model ID, model_name: Model name, model_version: Model version, model_path: Model path, deployment_id: Deployment ID, deployment_name: Deployment name, service_name: Service name, api_key: API key',
    startupArgs: 'Startup Arguments',
    startupArgsTooltip:
      'Custom startup arguments that can be referenced in startup variables',
    environmentVariables: 'Environment Variables',
    environmentVariablesTooltip: 'Set environment variables for the container runtime, used to configure inference service parameters and behavior',
    expirationTime: 'Expiration Time',
    expirationTimeTooltip: 'The service will be automatically stopped and resources released after expiration. Leave empty for long-running services',
    selectExpirationTime: 'Select expiration time',
    serviceTraffic: 'Service Traffic',
    serviceTrafficTooltip:
      'Whether service traffic can only be received by master nodes',
    allNodes: 'All Nodes',
    masterNode: 'Master Node',
    ipWhitelist: 'IP Whitelist',
    ipWhitelistTooltip: 'Only IP addresses in the whitelist can access this service. Leave empty to allow access from all IPs',
    ipWhitelistPlaceholder: 'Support multiple IPs, separated by commas',
    hpa: 'HPA',
    hpaTooltip: 'Scale in and out automatically based on the average CPU/GPU utilization metrics of all instances in the inference service',
    submit: 'Submit',
    cancel: 'Cancel',
    update: 'Update',
    create: 'Create',
    updateInferenceService: 'Update inference service',
    createInferenceService: 'Create inference service',
    totalCost: 'Total Cost',
    perHour: '/Hour',
  },

  // Edit page
  editPage: {
    title: 'Inference Service Detail',
  },

  // WorkloadPodList component translations
  podList: {
    name: 'Name',
    status: 'Status',
    node: 'Node',
    ip: 'IP',
    startTime: 'Start Time',
    operations: 'Operations',
    viewLogs: 'View Logs',
    viewEvents: 'View Events',
    loginContainer: 'Login Container',
  },
}

export default translation
